/**
 * Checks whether chrome.runtime?.id is truthy. If it's not, the function does nothing
 */
export function withChromeRuntime<T>(fn: () => T) {
  if (hasChromeRuntime()) {
    return fn();
  }
}

export function hasChromeRuntime(): boolean {
  return !!chrome && !!chrome.runtime?.id;
}
